"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _I18n = _interopRequireDefault(require("I18n"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _useUniqueId = _interopRequireDefault(require("react-utils/hooks/useUniqueId"));

var _FieldsetContext = require("../context/FieldsetContext");

var _SimpleDate = require("../core/SimpleDate");

var _SyntheticEvent = _interopRequireDefault(require("../core/SyntheticEvent"));

var _Controllable = _interopRequireDefault(require("../decorators/Controllable"));

var _ShareInput = _interopRequireDefault(require("../decorators/ShareInput"));

var _UIInputIconWrapper = _interopRequireDefault(require("../input/internal/UIInputIconWrapper"));

var _UITextInput = _interopRequireDefault(require("../input/UITextInput"));

var _SimpleDateTypes = require("../types/SimpleDateTypes");

var _Dom = require("../utils/Dom");

var _DomEvents = require("../utils/DomEvents");

var _Locale = require("../utils/Locale");

var _memoWithDisplayName = _interopRequireDefault(require("../utils/memoWithDisplayName"));

var _createLazyPropType = _interopRequireDefault(require("../utils/propTypes/createLazyPropType"));

var _decorators = require("../utils/propTypes/decorators");

var _deprecated = _interopRequireDefault(require("../utils/propTypes/deprecated"));

var _refObject = _interopRequireDefault(require("../utils/propTypes/refObject"));

var _AbstractCalendar = _interopRequireDefault(require("./internal/AbstractCalendar"));

var _CalendarPagePopover = _interopRequireDefault(require("./internal/CalendarPagePopover"));

var _UsesToday = _interopRequireDefault(require("./internal/UsesToday"));

var isValidValue = function isValidValue(value, minValue, maxValue) {
  if (value == null) return true;
  if (!(0, _SimpleDate.isValid)(value)) return false;
  return (0, _SimpleDate.isDateInRange)(value, minValue, maxValue);
};

var UIDateInput = (0, _memoWithDisplayName.default)('UIDateInput', function (props) {
  var ariaInvalid = props['aria-invalid'],
      ariaLabel = props['aria-label'],
      ariaLabelledBy = props['aria-labelledby'],
      ariaRequired = props['aria-required'],
      autoFocus = props.autoFocus,
      calendarPage = props.calendarPage,
      className = props.className,
      clearLabel = props.clearLabel,
      disabled = props.disabled,
      disabledValues = props.disabledValues,
      error = props.error,
      focusedValue = props.focusedValue,
      format = props.format,
      iconSize = props.iconSize,
      id = props.id,
      Input = props.Input,
      inputRef = props.inputRef,
      inputWidth = props.inputWidth,
      min = props.min,
      minValue = props.minValue,
      max = props.max,
      maxValue = props.maxValue,
      maxValidationMessage = props.maxValidationMessage,
      maxValueValidationMessage = props.maxValueValidationMessage,
      minValidationMessage = props.minValidationMessage,
      minValueValidationMessage = props.minValueValidationMessage,
      name = props.name,
      onCalendarPageChange = props.onCalendarPageChange,
      onChange = props.onChange,
      __onFocusedValueChange = props.onFocusedValueChange,
      onOpenChange = props.onOpenChange,
      open = props.open,
      readOnly = props.readOnly,
      required = props.required,
      today = props.today,
      todayLabel = props.todayLabel,
      use = props.use,
      value = props.value,
      rest = (0, _objectWithoutProperties2.default)(props, ["aria-invalid", "aria-label", "aria-labelledby", "aria-required", "autoFocus", "calendarPage", "className", "clearLabel", "disabled", "disabledValues", "error", "focusedValue", "format", "iconSize", "id", "Input", "inputRef", "inputWidth", "min", "minValue", "max", "maxValue", "maxValidationMessage", "maxValueValidationMessage", "minValidationMessage", "minValueValidationMessage", "name", "onCalendarPageChange", "onChange", "onFocusedValueChange", "onOpenChange", "open", "readOnly", "required", "today", "todayLabel", "use", "value"]);
  var calendarId = (0, _useUniqueId.default)('dateinput-calendar-');
  var popoverId = (0, _useUniqueId.default)('dateinput-popover-');
  var fieldsetContext = (0, _react.useContext)(_FieldsetContext.FieldsetContext);
  var computedDisabled = disabled || fieldsetContext.disabled;

  var triggerOpen = function triggerOpen() {
    if (readOnly || computedDisabled) return;
    onOpenChange((0, _SyntheticEvent.default)(true));
  };

  return _react.default.createElement(_AbstractCalendar.default, props, function (_ref) {
    var onInputChange = _ref.onInputChange,
        onKeyDown = _ref.onKeyDown,
        onKeyUp = _ref.onKeyUp,
        onBlur = _ref.onBlur,
        inputValue = _ref.inputValue;
    return _react.default.createElement(_CalendarPagePopover.default, {
      calendarId: calendarId,
      calendarPage: calendarPage,
      clearLabel: clearLabel,
      disabledValues: disabledValues,
      focusedValue: focusedValue,
      id: popoverId,
      max: max || maxValue,
      min: min || minValue,
      maxValidationMessage: maxValidationMessage || maxValueValidationMessage,
      minValidationMessage: minValidationMessage || minValueValidationMessage,
      onCalendarPageChange: onCalendarPageChange,
      onChange: onChange,
      onFocusLeave: function onFocusLeave() {
        onOpenChange((0, _SyntheticEvent.default)(false));
      },
      onMouseDown: _DomEvents.preventDefaultHandler
      /* keep input focused */
      ,
      onOpenChange: onOpenChange,
      open: open && !computedDisabled && !readOnly,
      today: today,
      todayLabel: todayLabel,
      value: value
    }, _react.default.createElement(_UIInputIconWrapper.default, Object.assign({}, rest, {
      className: className,
      disabled: computedDisabled,
      iconName: "date",
      size: iconSize || fieldsetContext.size
    }), _react.default.createElement(Input, {
      "aria-invalid": error ? 'true' : ariaInvalid,
      "aria-label": ariaLabel,
      "aria-labelledby": ariaLabelledBy,
      "aria-required": ariaRequired,
      autoComplete: "off",
      autoFocus: autoFocus,
      className: (0, _Dom.listAttrIncludes)(className, 'private-form__control--inline') ? 'private-form__control--inline' : undefined,
      "data-format": (0, _Locale.getLocalizedDateFormat)(format),
      disabled: computedDisabled,
      error: error || !isValidValue(value, minValue, maxValue),
      id: id,
      inputRef: inputRef,
      name: name,
      onBlur: onBlur,
      onChange: onInputChange,
      onClick: triggerOpen,
      onFocus: function onFocus(evt) {
        if (readOnly || computedDisabled) return;
        evt.target.select(); // inputRef is not yet available (see facebook/react#7769)

        triggerOpen();
      },
      onKeyDown: onKeyDown,
      onKeyUp: onKeyUp,
      placeholder: (0, _Locale.getDatePlaceholder)(format),
      readOnly: readOnly,
      required: required,
      use: use,
      value: inputValue,
      width: inputWidth
    })));
  });
});

var deprecatedMinMaxMessage = function deprecatedMinMaxMessage(propName) {
  var newPropName = propName.replace('Value', '');
  return {
    message: "UIDateInput: The `" + propName + "` prop is deprecated. Use `" + newPropName + "` instead.",
    key: 'UIDateInput-old-minmax'
  };
};

UIDateInput.propTypes = {
  'aria-invalid': _propTypes.default.string,
  'aria-label': _propTypes.default.string,
  'aria-labelledby': _propTypes.default.string,
  'aria-required': _propTypes.default.bool,
  autoFocus: _propTypes.default.bool,
  calendarPage: (0, _decorators.hidden)(_propTypes.default.shape({
    year: _propTypes.default.number.isRequired,
    month: _propTypes.default.number.isRequired
  })),
  clearLabel: (0, _createLazyPropType.default)(_propTypes.default.string),
  disabled: _propTypes.default.bool,
  disabledValues: _propTypes.default.arrayOf(_SimpleDateTypes.SimpleDateType),
  error: _propTypes.default.bool,
  focusedValue: (0, _decorators.hidden)(_SimpleDateTypes.SimpleDateType),
  format: _propTypes.default.oneOf(['L', 'YYYY-MM-DD']).isRequired,
  iconSize: (0, _decorators.hidden)(_propTypes.default.number),
  id: _propTypes.default.string,
  Input: (0, _decorators.hidden)(_propTypes.default.elementType.isRequired),
  inputRef: _refObject.default.isRequired,
  inputWidth: (0, _decorators.hidden)(_propTypes.default.number),
  max: _SimpleDateTypes.SimpleDateType,
  maxValidationMessage: (0, _createLazyPropType.default)(_propTypes.default.string),
  maxValue: (0, _deprecated.default)(_SimpleDateTypes.SimpleDateType, deprecatedMinMaxMessage),
  maxValueValidationMessage: (0, _deprecated.default)((0, _createLazyPropType.default)(_propTypes.default.string), deprecatedMinMaxMessage),
  min: _SimpleDateTypes.SimpleDateType,
  minValue: (0, _deprecated.default)(_SimpleDateTypes.SimpleDateType, deprecatedMinMaxMessage),
  minValidationMessage: (0, _createLazyPropType.default)(_propTypes.default.string),
  minValueValidationMessage: (0, _deprecated.default)((0, _createLazyPropType.default)(_propTypes.default.string), deprecatedMinMaxMessage),
  name: _propTypes.default.string,
  onCalendarPageChange: (0, _decorators.hidden)(_propTypes.default.func.isRequired),
  onChange: _propTypes.default.func.isRequired,
  onFocusedValueChange: (0, _decorators.hidden)(_propTypes.default.func.isRequired),
  onOpenChange: _propTypes.default.func.isRequired,
  open: _propTypes.default.bool.isRequired,
  readOnly: _propTypes.default.bool,
  required: _propTypes.default.bool,
  today: _SimpleDateTypes.SimpleDateType.isRequired,
  todayLabel: (0, _createLazyPropType.default)(_propTypes.default.string),
  use: _UITextInput.default.propTypes.use,
  value: _SimpleDateTypes.SimpleDateType
};
UIDateInput.defaultProps = {
  clearLabel: function clearLabel() {
    return _I18n.default.text('ui.datePicker.clear');
  },
  format: 'L',
  Input: _UITextInput.default,
  maxValidationMessage: function maxValidationMessage() {
    return _I18n.default.text('ui.datePicker.dateAboveMax');
  },
  minValidationMessage: function minValidationMessage() {
    return _I18n.default.text('ui.datePicker.dateBelowMin');
  },
  open: false,
  todayLabel: function todayLabel() {
    return _I18n.default.text('ui.datePicker.today');
  }
};

var _default = (0, _ShareInput.default)((0, _Controllable.default)((0, _UsesToday.default)(UIDateInput), ['calendarPage', 'focusedValue', 'open', 'value']));

exports.default = _default;
module.exports = exports.default;